// extracted by mini-css-extract-plugin
export default {"file-upload":"Q6VW41U2TJ8dDkMM3_5F","file-upload--dropzone":"ghkwCXyNlpBAz6q3xvgc"};